import { IToggleContainer, IValueFeature } from '@cemex-core/cmx-rollout-toggle-v1';

import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class CancelErrorHandlingTimeFeature implements IValueFeature {
  name = Features.CancelErrorHandlingTime;

  public getValue(container: IToggleContainer): number {
    return container[this.name].getValue();
  }
}
